<template>
  <div class="full-height">
    <div class="row container q-px-sm">
      <div class="fit">
        <q-card class="q-py-sm card-crud">
            <q-card-section class="q-py-sm card-title">
              <div class="crud-title">
                 {{ $gettext('WATCH') }}
              </div>
            </q-card-section>
          <q-card-section  class="tw-flex tw-flex-row tw-gap-4 tw-flex-between tw-w-full tw-h-full">
            <div class="tw-w-1/2">
              <info-box-panel class="tw-mt-4" :title="$gettext('CONSUMER_UNIT_INFO')">
                <template #body>
                  <div class="mb-4">
                    <info-box-panel-field :field="$gettext('ADDRESS')" :value="fullAddress" />
                    <info-box-panel-field :field="$gettext('NEIGHBORHOOD')" :value="neighborhood" />
                    <info-box-panel-field :field="$gettext('ZIP')" :value="cep" />
                    <info-box-panel-field :field="$gettext('ADDRESS_CITY')" :value="city" />
                    <info-box-panel-field :field="$gettext('ADDRESS_STATE')" :value="state" />
                  </div>
                </template>
              </info-box-panel>
            </div>
            <div class="tw-w-1/2">
              <info-box-panel class="tw-mt-4" :title="$gettext('REQUEST_INFO')">
                <template #body>
                  <div class="mb-4">
                    <info-box-panel-field :field="$gettext('PERIOD')" :value="period" />
                    <info-box-panel-field :field="$gettext('ORIGINAL_VALUE')" :value="$toLocaleStringBr(nominalValue)" />
                    <info-box-panel-field :field="$gettext('AMOUNT_PAID_VALUE')" :value="$toLocaleStringBr(writeOff)" />
                    <info-box-panel-field :field="$gettext('EXEMPTION_TYPE')" :value="getSettlementTypeByCode(invoiceSettlementType).text" />
                    <info-box-panel-field :field="$gettext('REASON')" :value="getOpenReason()" />
                    <info-box-panel-field
                      field="Arquivos"
                      :files="files"
                      fieldType="file"
                    >
                      <template #file-viewer>
                        <div class="flex items-center space-x-2" v-for="(file, index) in files" :key="index">
                          <button class="icon-button" @click="downloadFile(file.file)">
                            <q-icon :name="getIconComponent(getFileType(file.file)).icon" size="45px" />
                          </button>
                          <div>
                            <div class="value">
                              {{ file.observation || $gettext('NO_OBSERVATION') }}
                            </div>
                          </div>
                        </div>
                      </template>
                    </info-box-panel-field>
                  </div>
                </template>
              </info-box-panel>
            </div>
          </q-card-section>
          <q-card-section  class="tw-flex tw-flex-row tw-gap-4 tw-flex-between tw-w-full tw-h-full">
            <div class="tw-grid-rows tw-mt-8  tw-w-full tw-h-full">
              <info-box-panel class="tw-mt-4" :title="$gettext('APPROVAL_INFORMATIONS')">
                <template #body>
                  <div class="tw-flex tw-flex-row tw-gap-4 tw-flex-between tw-w-full tw-h-full" v-for="(history, index) in forms[0].dadosForm.invoiceSettlementHistorys" :key="index">
                    <div class="tw-w-1/2 mb-4">
                      <info-box-panel-field :field="labelAttendant(history)" :value="history.attendant" />
                    </div>
                    <div class="tw-w-1/2 mb-4">
                      <info-box-panel-field v-if="history.date" :field="$gettext('DATE_HOUR')" :value="parseDateHistory(history.date)" />
                    </div>
                    <div class="tw-w-1/2 mb-4">
                      <info-box-panel-field  v-if="history.invoiceSettlementStatusNumber != 50370001" :field="$gettext('STATUS')" :value="history.invoiceSettlementStatus " />
                    </div>
                  </div>
                  <span v-for="(history, index) in forms[0].dadosForm.invoiceSettlementHistorys" :key="index">
                    <div class="tw-flex tw-flex-row tw-gap-4 tw-flex-between tw-w-full tw-h-full">
                      <info-box-panel-field v-if="history.invoiceSettlementStatusNumber != 50370001 && history.observation" :field="$gettext('REASON')+' ['+history.invoiceSettlementStatus+']'" :value="history.observation" />
                    </div>
                  </span>
                </template>
              </info-box-panel>
            </div>
          </q-card-section>
          <q-card-section>
            <info-box-panel class="tw-mt-4" :title="$gettext('INVOICES_SUMMARY_STEP') ">
              <template #body>
                <service-request-invoice-settlement-datable class="tw-mt-3" v-if="columnList" :fields="columnList" :invoices="invoices"
                                                            noneselect rowKey="boundResidue" />
              </template>
            </info-box-panel>
          </q-card-section>
        </q-card>
      </div>
    </div>
    <div class="tw-flex tw-gap-4 tw-p-6 tw-flex-row tw-justify-center">
      <q-btn
        class="q-mt-md btn-deny"
        color="btn-deny"
        label="REPROVAR"
        :disable="!isPending"
        @click="showRejectModal = true"/>
      <q-btn
        class="q-mt-md btn-accept"
        color="btn-accept"
        label="APROVAR"
        :disable="!isPending"
        @click="showApprovalModal = true"/>
    </div>
    <confirmation-modal
      :visible="showApprovalModal"
      mode="approve"
      @approve="approve"
      @close="showApprovalModal = false"
    />

    <confirmation-modal
      :visible="showRejectModal"
      mode="deny"
      @deny="deny"
      @close="showRejectModal = false"
    />
    </div>
</template>
<script>
import Component from 'vue-class-component'
import InfoBoxPanel from './components/InfoBoxPanel.vue'
import InfoBoxPanelField from './components/InfoBoxPanelField.vue'
import InvoiceSettlementHistory from './components/InvoiceSettlementHistory.vue'
import AnalyzeInvoiceSettlementController from './AnalyzeInvoiceSettlementController'
import { repository } from 'src/jtech'
import ConfirmationModal from 'src/modules/concession/analyze-invoice-settlement/components/ConfirmationModal.vue'
import moment from 'moment'
import { settlementTypeMap } from './components/settlementTypeMap.js'
import ServiceRequestInvoiceSettlementDatable
  from '../service-request/view/financial/invoice/invoice-settlement/ServiceRequestInvoiceSettlementDatatable.vue'
import { __downloadFileWithoutExtension } from 'src/shared/global/UtilFile'
import { invoiceSettlementStatus } from 'src/shared/inf-tabela-descricao/InvoiceSettlementStatus.enum.js'

@Component({
  name: 'AnalyzeInvoiceSettlementDetail',
  components: { ServiceRequestInvoiceSettlementDatable, ConfirmationModal, InfoBoxPanelField, InfoBoxPanel, InvoiceSettlementHistory },
  props: {
    id: String,
    interface: String,
    name: String,
    page: Object,
    forms: Object,
    data: Object,
    datatable: Object,
    params: Object
  }
})

class AnalyzeInvoiceSettlementDetail extends Component {
  analyzeInvoiceSettlementController = AnalyzeInvoiceSettlementController.getInstance();
  columns = null;
  historic = [];
  showApprovalModal = false;
  showRejectModal = false;
  moment = moment;

  get columnList () {
    return this.forms[0].inputs[0].columns
  }

  get invoices () {
    return this.forms[0].relacionamentos.invoiceSettlementInvoices
  }

  get isPending () {
    return this.forms[0].dadosForm.status === this.invoiceSettlementStatus.PENDING.key
  }

  get address () {
    return this.getAddressField('address_name')
  }

  get consumerUnit () {
    return this.getAddressField('consumerUnit')
  }

  get neighborhood () {
    return this.getAddressField('neighborhood')
  }

  get cep () {
    return this.getAddressField('zipCode')
  }

  get city () {
    return this.getAddressField('city')
  }

  get number () {
    return this.getAddressField('number') || ''
  }

  get detail () {
    return this.getAddressField('detail') || ''
  }

  get state () {
    return this.getAddressField('state')
  }

  get fullAddress () {
    return [this.address, this.number, this.detail]
      .filter(field => field !== null && field !== '')
      .join(', ')
  }

  get period () {
    return this.forms[0].relacionamentos.invoiceSettlementInvoices[0].period
  }

  get settlementType () {
    return settlementTypeMap()
  }

  get invoiceSettlementStatus () {
    return invoiceSettlementStatus()
  }

  get invoiceSettlementType () {
    return this.forms[0].dadosForm.invoiceSettlementType
  }

  labelAttendant (history) {
    return history.invoiceSettlementStatusNumber == 50370001 ? this.$gettext('ATTENDANT') : this.$gettext('APPROVER')
  }

  getSettlementTypeByCode (code) {
    if (code) {
      for (const settlement in this.settlementType) {
        if (
          Object.prototype.hasOwnProperty.call(this.settlementType, settlement)
        ) {
          const settlementKeys = this.settlementType[settlement].keys || []
          if (settlementKeys.includes(code)) {
            return this.settlementType[settlement]
          }
        }
      }
    }
    return { text: code, color: '#fff' }
  }

  get status () {
    return this.forms[0].dadosForm.status
  }

  get files () {
    return this.forms[0].relacionamentos.invoiceSettlementFiles
  }

  async deny (observation) {
    var id = this.forms[0].dadosForm.invoiceSettlementId
    try {
      await this.analyzeInvoiceSettlementController.deny({ id: id, observation: observation })
      this.$q.loading.hide()
      this.params.params.crudLayout.removePage(this)
      this.params.params.crudLayout.setPage('approvation_page')
    } catch (error) {
      this.$q.loading.hide()
      this.$q.notify({
        type: 'negative',
        message: this.$gettext('DENIAL_FAILED_FOR_ITEM')
      })
    }
  };

  async approve () {
    var id = this.forms[0].dadosForm.invoiceSettlementId
    this.$q.loading.show({
      message: this.$gettext('APPROVING_ITEM')
    })
    try {
      await this.analyzeInvoiceSettlementController.approve(id)
      this.$q.loading.hide()
      this.params.params.crudLayout.removePage(this)
      this.params.params.crudLayout.setPage('approvation_page')
    } catch (error) {
      this.$q.loading.hide()
      this.$q.notify({
        type: 'negative',
        message: this.$gettext('APPROVAL_FAILED_FOR_ITEM')
      })
    }
  }

  getFileType (file) {
    const extension = file.split('.').pop().toLowerCase()

    if (['pdf', 'doc', 'docx', 'xls', 'xlsx', 'txt'].includes(extension)) {
      return 'documento'
    } else if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension)) {
      return 'imagem'
    } else if (['mp4', 'avi', 'mov', 'wmv', 'mkv'].includes(extension)) {
      return 'video'
    } else {
      return 'mdi-paperclip'
    }
  }

  getIconComponent (tipo) {
    switch (tipo) {
      case 'documento':
        return { icon: 'mdi-paperclip' }
      case 'imagem':
        return { icon: 'mdi-image-multiple' }
      case 'video':
        return { icon: 'mdi-video' }
      default:
        return { icon: 'mdi-file-outline' }
    }
  }

  async downloadFile (filePath) {
    const file = await repository.downloadFile(filePath, null, 'INVOICE_SETTLEMENT')
    __downloadFileWithoutExtension(file, filePath)
  }

  getAddressField (field) {
    return this.forms[0].dadosForm.address.find(
      (address) => address.addressPersonType === 20030001
    )[field]
  }

  get nominalValue () {
    return this.forms[0].dadosForm.nominalValue
  }

  get writeOff () {
    return this.forms[0].dadosForm.writeOff
  }

  get datatableModel () {
    return this.historic
  }

  parseDateHistory (date) {
    return moment(date, 'YYYY-MM-DD HH:mm:ss.SSS').format('DD/MM/YYYY HH:mm:ss')
  }

  getOpenReason () {
    return this.forms[0].dadosForm.invoiceSettlementHistorys.find(
      history => history.invoiceSettlementStatusNumber === 50370001)?.observation
  }
}

export default AnalyzeInvoiceSettlementDetail
</script>
<style scoped>
@import "tailwindcss/utilities";
.cell-values {
  display: flex;

  flex-direction: column;
}

.fit {
  background-color: #fff;
}

.table {
  margin-top: 140px;
}

.buttons-area {
  height: 55px;
  display: flex;
}

.index-table {
  width: 45%;
  margin-left: 16px;
}

.rigth-buttons {
  width: 55%;
  display: flex;
  justify-content: flex-end;
}

.sub-teble-btn {
  color: #555;
}

.top-area {
  display: flex;
  justify-content: space-around;
  padding: 17px 0;
}

.block-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f1f1f1;
}

hr {
  color: #707070;
}
.subtitle {
  color: #707070;
  font-size: 2em;
  font-weight: bold;
}

.btn-back {
  color: #fff;
  background-color: #6f8896;
}

.btn-deny {
  background-color: #e25959;
  color: #fff;
}

.btn-accept {
  background-color: #00c79e;
  color: #fff;
}

.icon-button {
  background: none;
  border: none;
  cursor: pointer;
}

</style>
